/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Cargando...',
	'dlg_close': 'Cerrar',
	'dlg_ok': 'Aceptar',
	'dlg_cancel': 'Cancelar',
	'dlg_back': 'Retroceder',
	'dlg_done': 'Listo',

	// Slider
	'sliderRegionLabel': 'Control del deslizador, utilice las flechas derecha e izquierda para mover los puntos de arrastre del deslizador',
	'sliderHandleLabel': 'Punto de arrastre del deslizador',
	'a11ySliderHandleLabel': 'Punto de arrastre del deslizador %{sliderValue}',
	'sliderInputLabel': 'valor',

	// Side bar
	'sidebarAdd': 'Añadir',
	'clearTextFilterValue': 'Borrar',
	'missingDataSetData': 'Los datos para este conjunto de datos no están disponibles. Renueve el conjunto de datos o póngase en contacto con el administrador para acceder al origen.',

	// Toolbar
	'toolbarRegionLabel': 'Barra de herramientas',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Familia de fuentes',
	'fontSizeSelect': 'Tamaño de fuente',
	'fontColorSelect': 'Color',
	'fontStyle': 'Estilo',
	'colorPickerTitle': 'Seleccionando un color',
	'bold': 'Negrita',
	'italic': 'Cursiva',
	'underline': 'Subrayado',
	'fontAlignment': 'Alineación',
	'justifyLeft': 'Alinear a la izquierda',
	'justifyCenter': 'Alinear al centro',
	'justifyRight': 'Alinear a la derecha',
	'insertOrderedList': 'Lista ordenada',
	'insertUnorderedList': 'Lista no ordenada',
	'fontColorPicker': 'Selector de color',
	'textWrap': 'Ajustar texto',
	'restore': 'Restaurar valores predeterminados',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Número de resultados (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Porcentaje (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Opción de parte superior o inferior',
	'topbottomOptionLabel': 'Mostrar',
	'searchByLabel': 'Por',
	'searchNoMatches': 'No se han encontrado coincidencias',
	'topbottomRankColumnLabel': 'Añadir una columna de clasificación a la tabla',
	'topbottomNone': 'Ninguno',
	'topCount': 'Recuento superior',
	'topPercent': 'Mejor %',
	'bottomCount': 'Recuento inferior',
	'bottomPercent': 'Peor %',
	'searchColumn': 'Buscar una columna',
	'searchColumnAriaLabel': 'Buscar una columna. Escriba el nombre de la columna en la que buscar y, a continuación, utilice la flecha hacia abajo para buscar la columna en una lista',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rango (%{columnLabel})',
	'topbottomClearLabel': 'Restablecer',

	// Format
	'formatAuto': 'Automático',
	'formatConvertPercent': 'Convertir decimal a porcentaje',
	'formatAbbreviate': 'Abreviar',
	'formatUseGrouping': 'Usar separador de miles',
	'dateStyle': 'Estilo de datos',
	'dateTimeStyle': 'Estilo fecha/hora',
	'formatMissingValueCharactersInfo': 'Los caracteres del valor que falta especifican el carácter o caracteres que se mostrarán si falta el valor.',
	'currencySymbolLabel': 'Símbolo de moneda',
	'customSymbolPlaceholder': 'Añadir un símbolo',
	'customSymbolLabelInfo': 'Especifica uno o varios caracteres que se han de utilizar como un símbolo personalizado. Este símbolo irá delante del número y de cualquier signo.',
	'numberLabel': 'Etiqueta de número',
	'numberPositionLabel': 'Posición de la etiqueta',
	'numberLabelInfo': 'Especifica una etiqueta para el número con formato y se coloca como un prefijo o sufijo en función de la posición de la etiqueta.',
	'nullValueDefault': '<predeterminado>',
	'nullValueContent': '(ningún valor)',
	'default': 'Valor predeterminado',
	'beginning': 'Principio',
	'end': 'Fin',
	'formatLabel': 'Seleccionar un formato',

	// More data indicator
	'moreDataIndicator': 'Sus datos se han recortado en %{threshold} elementos. Aplique el filtro para mostrar menos.',

	// Expanded View / Focus mode
	'evCollapse': 'Contraer',
	'duplicate': 'Duplicar',
	'copyOf': 'Copia del %{name}',
	'unableToDuplicateBoard': 'No se ha podido duplicar "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'No podemos cargar los objetos.',

	// Custom widgets
	'customWidget': 'Widget personalizado'
});
